import { LabelsMap } from 'new/form/common/types';

import { companyDetailsCompletionSectionLabelsMap } from './sections/companyDetailsCompletion/labels';
import { companySearchSectionLabelsMap } from './sections/companySearch/labels';

export const companyDataPageLabelsMap: LabelsMap = {
  ...companySearchSectionLabelsMap,
  ...companyDetailsCompletionSectionLabelsMap,
};
